import React from 'react';
import TargetFieldDocumentTypeField from './DocumentTypeField';
import InnerTargetField from '../InnerTargetField';


const TargetFieldDataForDocument = ({ fieldName, readOnly = false }) => {
  return (
    <>
      <TargetFieldDocumentTypeField fieldName={fieldName} readOnly={readOnly}/>
      <InnerTargetField fieldName={fieldName} readOnly={readOnly}/>
    </>
  );
};

export default  TargetFieldDataForDocument;